/* global G */
import { curry, type PlatformEvent } from 'lib/util'
import find from 'lib/sequence/component/children/find'

/**
 * Clears the state of the `scanner` and `scanResult` elements, so that a new scanning process can
 * start.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const resetScan = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
) => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { scanner, scanResult } = find(actionComponent)

  scanner[G.STATE].scan = {}
  scanResult[G.STATE].data = null
  scanResult[G.STATE].reload = {}

  await module[G.ADAPTER][G.UI].update(module)
}

export default curry(resetScan)
